var agi = agi || {};
agi.expressions = agi.expressions || {};

(function(Utils, ExpressionSorry, ExpressionBCVideo) {
    "use strict";
    /**
     * An Expression represents a Digital Expression product.
     * Web page code should interact with this type of product only
     * through the public API defined below.
     *
     * @class Expression
     * @constructor
     */
    function Expression() {
        this.prod = undefined;
        this.env = undefined;
        this.subtype = undefined;
    };

    var p = Expression.prototype;

    // public methods:

    /**
     * Bootstraps display of a product
     *
     * @param {Object} env Product environment.
     * @public
     */
    p.init = function init(env, prod) {
        this.env = env;
        this.prod = prod;
        this.bootstrapProduct();
        this.defaultPers = {};
    };

    /**
     * Destroy any sound and/or visual of the product.
     * Restore product's initial state so that init() can be called again.
     *
     * @public
     */
    p.destroy = function destroy() {
        this.delegate('destroy');
    };

    /**
     * Replays the product from the beginning
     *
     * @public
     */
    p.replay = function replay() {
        this.delegate('replay');
    };

    /**
     * This is only needed for content where personalization happens
     * within the product itself (e.g. NETA prompt in C3).
     *
     * @param {Object} pers A personalization object with key, value pairs
     * @public
     */
    p.send = function send(pers) {
        if (!pers || pers === "undefined") {
            pers = this.formatDefaultPers();
        }

        var sendForm = document[this.env.orderForm];
        this.storePers(pers, sendForm);

        if (this.env.nextPage) {
            sendForm.action = this.env.nextPage;
        }

        sendForm.submit();
    };

    p.formatDefaultPers = function formatDefaultPers() {
        return encodeURIComponent(JSON.stringify(this.defaultPers));
    };

    p.storePers = function storePers(pers, sendForm) {
        if (this.env.storePersInCookie) {
            this.storePersInCookie(pers);
        }
        else {
            sendForm[this.env.NETAPrompt].value = pers;
        }
    };

    /**
     * When storing the product personalizations in a cookie, we also
     * need a unique identifier, so we also store the prodnum.

     * @param {Object} pers A personalization object with key, value pairs
     * @public
     */
    p.storePersInCookie = function storePersInCookie(pers) {
        var key = this.env.NETAPrompt;

        var params = {
            prodnum: this.prod.id,
            pers: btoa(pers)
        }

        MagicCookie.setCookieValue(key, JSON.stringify(params));
    };

    /**
     * Skip to show the last frame of the product
     *
     * @public
     */
    p.skipToEnd = function skipToEnd() {
        this.delegate('skipToEnd');
    };

    // private methods:

    /**
     * Check product json to determine whether additional
     * scripts need to be loaded. Then kickstarts init()
     * call in product specified namespace
     *
     * @private
     */
    p.bootstrapProduct = function bootstrapProduct() {
        if (this.prod && this.prod.namespace) {
            this.subtype = this.getSubtype();
            if (this.isCompatable()) {
                if (this.prod.script) {
                    this.loadScript();
                } else {
                    this.delegate('init');
                }
            }
            else {
                if (this.subtype === "IVEX") {
                    ExpressionBCVideo.init(this.env, this.prod, this);
                } else {
                    ExpressionSorry.init(this.env);
                }
            }
        } else {
            throw new Error("Expression: product json missing critical keys");
        }
    };

    /**
     * Loads in a javascript
     *
     * @private
     */
    p.loadScript = function loadScript() {
        var url = this.env.imghost + "/" + this.prod.script;
        Utils.loadJavaScriptFile(url, this.scriptLoadedHandler.bind(this),
                                    this.scriptLoadFailedHandler.bind(this));
    };

    /**
     * Puts loaded javascript on the page and call its "init" function
     *
     * @private
     */
    p.scriptLoadedHandler = function scriptLoadedHandler() {
        this.delegate('init');
    };

    /**
     * Delegate function calls
     *
     * @private
     */
    p.delegate = function delegate(functionName) {
        Utils.executeFunctionByName(this.prod.namespace + "." + functionName,
                                    window, this.env, this.prod, this);
    };

    /**
     * Handler if loading javascript failes
     *
     * @private
     */
    p.scriptLoadFailedHandler = function scriptLoadFailedHandler() {
        throw new Error("Expression: script load failed");
    };

    /**
     * Gets the correct subtype label based on the naespace
     *
     * @private
     */
    p.getSubtype = function getSubtype() {
        var namespace = this.prod.namespace;
        if (namespace === "agi.expressions.ExpressionManager"){
            return "IDEX";
        }
        else if (namespace === "agi.expressions.IVEXExpressionManager"){
            return "IVEX";
        }
        else if (namespace.indexOf("General") > 0){
            return "GENERAL";
        }

        return undefined;
    };

    /**
     * Checks to see if the users browser is compatible
     * with expression products.
     * NOTE: This should be replaced with compatibility/feature
     *       testing.
     *
     * @private
     */
    p.isCompatable = function isCompatable() {
        var ieVersion = parseInt(this.env.isIE);

        switch (this.subtype){
            case "IDEX":
                if (ieVersion > 0 && ieVersion < 11){
                    return false;
                }
                break;
            case "IVEX":
                if ((ieVersion > 0 && ieVersion < 11) || this.env.isIphone){
                    return false;
                }
                break;
            case "GENERAL":
                if (ieVersion > 0 && ieVersion < 10){
                    return false;
                }
                break;
        }

        return true;
    };

    agi.expressions.Expression = Expression;
})(agi.expressions.Utils, agi.expressions.ExpressionSorry, agi.expressions.ExpressionBCVideo)
